import axiosInstance from '../../../helpers/backend_helper';

const getStoryById = async (id) => {
  try {
    const response = await axiosInstance.get(`stories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching book with ID ${id}:`, error);
    throw error;
  }
};

export default getStoryById;
